import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialAnnotationType } from '../../material-annotation-list.model';
import { ButtonModule } from '@mhe/ngx-shared';
import { TooltipModule } from '@mhe/ngx-shared/tooltip';

@Component({
  selector: 'rdrx-material-annotation-list-menu',
  template: `
    <button
      mhe-button
      [matMenuTriggerFor]="beforeMenu"
      aria-label="Options"
      class="kebab-button"
      tabindex="0"
      data-automation-id="btn-options-menu"
      [mheTooltip]="
        type === MaterialAnnotationType.HIGHLIGHTS
          ? ('contents.menu_highlights' | translate)
          : type === MaterialAnnotationType.NOTES
          ? ('contents.menu_notes' | translate)
          : type === MaterialAnnotationType.PLACEMARKS
          ? ('contents.menu_placemarks' | translate)
          : ''
      "
      >
      <span class="kebab-menu-icon"></span>
    </button>

    <mat-menu class="contents-dropdown" #beforeMenu="matMenu" xPosition="before">
      @switch (type) {
        @case (MaterialAnnotationType.HIGHLIGHTS) {
          <button mat-menu-item
            data-automation-id="menu-edit-highlights"
            (click)="editModeMenuSelected.emit(true)">
            {{ "contents.menu_edit_highlights" | translate }}
          </button>
          <button mat-menu-item
            data-automation-id="menu-export-highlights"
            (click)="handleExportBtn($event)">
            {{ "contents.menu_export_highlights" | translate }}
          </button>
        }
        @case (MaterialAnnotationType.NOTES) {
          <button mat-menu-item
            data-automation-id="menu-edit-notes"
            (click)="editModeMenuSelected.emit(true)">
            {{ "contents.menu_edit_notes" | translate }}
          </button>
          <button mat-menu-item
            data-automation-id="menu-export-notes"
            (click)="handleExportBtn($event)">
            {{ "contents.menu_export_notes" | translate }}
          </button>
        }
        @case (MaterialAnnotationType.PLACEMARKS) {
          <button mat-menu-item
            data-automation-id="menu-edit-placemarks"
            (click)="editModeMenuSelected.emit(true)">
            {{ "contents.menu_edit_placemarks" | translate }}
          </button>
        }
      }
    </mat-menu>
    `,
  styleUrls: ['./material-annotation-list-menu.component.scss'],
  imports: [
    TranslateModule,
    A11yModule,
    OverlayModule,
    MatMenuModule,
    ButtonModule,
    TooltipModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialAnnotationListMenuComponent {
  MaterialAnnotationType = MaterialAnnotationType;
  @Input({ required: true }) type!: MaterialAnnotationType;
  @Output() editModeMenuSelected = new EventEmitter();
  @Output() exportAnnotations = new EventEmitter();

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.menuTrigger.openMenu();
    }
  }

  handleExportBtn(evt: Event): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.exportAnnotations.emit();
  }
}
